import { Box } from '@material-ui/core';

interface SaveErrorProps {
  error?: unknown;
}

export default function SaveError({ error }: SaveErrorProps) {
  if (!error) return null;

  const message =
    typeof error === 'string' ? error : error instanceof Error ? error.message : JSON.stringify(error, null, 2);

  return (
    <Box mt={2}>
      <pre
        style={{
          color: '#f44336',
          margin: 0,
          whiteSpace: 'pre-wrap',
          overflow: 'auto',
        }}
      >
        {message}
      </pre>
    </Box>
  );
}
